import React from 'react';
import { Spin } from 'antd';
import './Spinner.css';
import {isNullOrUndefined} from "../../utils";

interface SpinnerProps {
    loading?: boolean;
    percent?: number;
    className?: string;
    spinnerIcon?: React.ReactElement<any>;
}

const Spinner: React.FC<SpinnerProps> = (props) => {
    const {className, spinnerIcon, loading, percent} = props;
    const containerClassName: string = 'spinner-container' + (className ? '-' + className : '');
    const spinnerClassName: string =  'spinner' + (className ? '-' + className : '');
    const percentValue = `${percent ?? 20}%` ;

    if (!isNullOrUndefined(loading)) {
        if (!loading) {
            return null;
        }
    }

    const indicator = spinnerIcon ?? <img alt={"spinner"} style={{width: percentValue, height: 'auto'}} src={'/spinner.svg'}/>;

    return (
        <div className={containerClassName}>
            <Spin className={spinnerClassName} indicator={indicator} />
        </div>
    );
};

export default Spinner;